// extracted by mini-css-extract-plugin
export default {"root":"_314CQ","small":"_39CIf","normal":"_3OnMa"};